/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {BackfillJoinedAtRequest} from '@cash-web/protos/squareup/cash/cashcustomerprofile/api/v1/backfill_joined_at.pb'
import {BackfillJoinedAtResponse} from '@cash-web/protos/squareup/cash/cashcustomerprofile/api/v1/backfill_joined_at.pb'


export const backfillJoinedAt = (request: BackfillJoinedAtRequest, options?: CashRequestOptions) => post<BackfillJoinedAtRequest, BackfillJoinedAtResponse>("/2.0/cash/backfill-joined-at", request, {...options, rejectOnError: true })